import {BookOpenText, Languages} from "lucide-react";
import {DataState} from "../../../shared/components/DataState";
import {ToolbarSelect} from "../../../shared/components/PageToolbar";
import {useTranslation, i18n} from "../../../shared/i18n";


const valuesFromLocaleData = (data) => Object.entries(data || {}).flatMap(([key, value]) => {
    if (value === null || value === undefined || value === "") return [];
    if (typeof value === "object") return valuesFromLocaleData(value);
    return [{key, value: String(value)}];
});

export const SlidesWorkspace = ({locale, setLocale, localeOptions, query}) => {
    const {t} = useTranslation();
    const slides = query.data?.slides || [];
    const localeCopy = valuesFromLocaleData(query.data?.locale_data);
    const error = query.error?.response?.data?.message || query.error?.message;

    return (
        <div className="content-workspace">
            <div className="content-workspace-head">
                <div><h2>{t("sections.content.p27")}</h2><p>{t("sections.content.p305")}</p></div>
                <ToolbarSelect aria-label={t("sections.content.p306")} label={t("sections.content.p172")} value={locale} onChange={(event) => setLocale(event.target.value)}>
                    {localeOptions.map((item) => <option key={item} value={item}>{item.toUpperCase()}</option>)}
                </ToolbarSelect>
            </div>
            <div className="content-readonly-note"><BookOpenText size={16} /><span>{t("sections.content.p307")}</span></div>
            {localeCopy.length ? <section className="content-locale-copy"><h3><Languages size={15} /> {t("sections.content.p308")}</h3><dl>{localeCopy.map((item, index) => <div key={`${item.key}-${index}`}><dt>{item.key.replaceAll("_", " ")}</dt><dd>{item.value}</dd></div>)}</dl></section> : null}
            {query.isError ? <DataState title={t("sections.content.p309")} copy={error || t("sections.content.p242")} /> : query.isLoading ? <div aria-label={t("sections.content.p310")} className="content-media-loading"><span /><span /><span /></div> : slides.length ? (
                <div className="content-slide-list">{slides.map((slide, index) => <article className="content-slide-card" key={slide.id}>{slide.image ? <img alt={slide.title || i18n.t("sections.content.p311", {v0: index + 1})} src={slide.image} /> : <div className="content-slide-placeholder">{index + 1}</div>}<div><span>{i18n.t("sections.content.p312")} {index + 1}</span><h3>{slide.title || i18n.t("sections.content.p313", {v0: slide.id})}</h3>{(slide.texts || []).map((text) => <p key={text}>{text}</p>)}</div></article>)}</div>
            ) : <DataState title={t("sections.content.p314")} copy={t("sections.content.p315")} />}
        </div>
    );
};
